(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dw-product-template-compatible-products"] && !Shopify.designMode) return;
  try {
    const loadMoreButton = document.getElementById('compatible-load-more')
  const showLessButton = document.getElementById('compatible-show-less')

  const getHiddenCards = (scopeSelector = '#compatible-products-list') =>
    document.querySelectorAll(`${scopeSelector} compatible-card[hidden]`)

  const filterStrapsSelect = document.getElementById('compatible-filter-straps-select')
  const filterJewellerySelect = document.getElementById('compatible-filter-jewellery-select')
  const strapsBtn = document.getElementById('compatible-toggle-straps')
  const jewelleryBtn = document.getElementById('compatible-toggle-jewellery')
  const productsContainer = document.getElementById('compatible-products-list')
  const jewelleryContainer = document.getElementById('compatible-jewellery-list')

  const applyFilter = (toLoad) => {
    console.log('loadMoreButton',loadMoreButton)
    if (!toLoad) {
      toLoad = parseInt(loadMoreButton.dataset.loadMore)
    }
    const activeFilter = (productsContainer && !productsContainer.hidden) ? filterStrapsSelect : filterJewellerySelect
    if (!activeFilter) return
    const val = (activeFilter.value || '').toLowerCase()

    const activeScope = (productsContainer && !productsContainer.hidden) ? '#compatible-products-list' : '#compatible-jewellery-list'
    const cards = document.querySelectorAll(`${activeScope} compatible-card`)

    let showCount = 0
    let filteredCount = 0
    cards.forEach(card => {
      const type = (card.dataset.productType || '').toLowerCase()
      if (!val || val === '' || type === val) {
        filteredCount++
        if(loadMoreButton && showCount >= toLoad) {
          card.hidden = true
          return
        }
        card.hidden = false
        showCount++
      } else {
        card.hidden = true
      }
    })
    console.log(`Of ${cards.length} cards: Found ${filteredCount} items matching filter "${val}"` + `, showing ${showCount} of them`)
    
    if (loadMoreButton) {
      if (showCount >= filteredCount) {
        loadMoreButton.hidden = true
      } else {
        loadMoreButton.hidden = false
      }
    }

    if (showLessButton) {
      if(toLoad <= parseInt(showLessButton.dataset.loadMore)) {
        showLessButton.hidden = true
      } else {
        showLessButton.hidden = false
      }
    }
  }

  const setActiveTab = (target) => {
    if (target === 'products') {
      if (productsContainer) productsContainer.hidden = false
      if (jewelleryContainer) jewelleryContainer.hidden = true
      if (strapsBtn) strapsBtn.classList.add('is-active')
      if (jewelleryBtn) jewelleryBtn.classList.remove('is-active')
      if(filterJewellerySelect) filterJewellerySelect.classList.add('hidden')
      if(filterStrapsSelect) filterStrapsSelect.classList.remove('hidden')
      applyFilter()
    } else {
      if (productsContainer) productsContainer.hidden = true
      if (jewelleryContainer) jewelleryContainer.hidden = false
      if (strapsBtn) strapsBtn.classList.remove('is-active')
      if (jewelleryBtn) jewelleryBtn.classList.add('is-active')
      if(filterJewellerySelect) filterJewellerySelect.classList.remove('hidden')
      if(filterStrapsSelect) filterStrapsSelect.classList.add('hidden')
      applyFilter()
    }
  }

  if (strapsBtn) strapsBtn.addEventListener('click', () => setActiveTab('products'))
  if (jewelleryBtn) jewelleryBtn.addEventListener('click', () => setActiveTab('jewellery'))
  
  if (filterJewellerySelect) filterJewellerySelect.addEventListener('change', () => applyFilter())
  if (filterStrapsSelect) filterStrapsSelect.addEventListener('change', () => applyFilter())

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', (e) => {
      const activeScope = (productsContainer && !productsContainer.hidden) ? '#compatible-products-list' : '#compatible-jewellery-list'
      const hiddenCards = document.querySelectorAll(`${activeScope} compatible-card[hidden]`)
      const totalCards = document.querySelectorAll(`${activeScope} compatible-card`).length
      applyFilter(totalCards - hiddenCards.length + parseInt(loadMoreButton.dataset.loadMore))
    })
  }

  if (showLessButton) {
    showLessButton.addEventListener('click', (e) => {
      const activeScope = (productsContainer && !productsContainer.hidden) ? '#compatible-products-list' : '#compatible-jewellery-list'
      const hiddenCards = document.querySelectorAll(`${activeScope} compatible-card[hidden]`)
      const totalCards = document.querySelectorAll(`${activeScope} compatible-card`).length
      console.log('showing: ',totalCards - hiddenCards.length)
      let toLoad = totalCards - hiddenCards.length - parseInt(showLessButton.dataset.loadMore)
      if (toLoad < parseInt(showLessButton.dataset.loadMore)) {
        toLoad = parseInt(showLessButton.dataset.loadMore)
      }
      applyFilter(toLoad)
    })
  }

  document.addEventListener('product:variantChange', async ({ detail: currentVariant }) => {
    const compatibleProducts = document.getElementById('compatible-products-list')
    if (compatibleProducts) {
      const response = await fetch(`${currentVariant.url}?variant=${currentVariant.id}&view=compatible`)
      compatibleProducts.innerHTML = await response.text()

      applyFilter()

      if (loadMoreButton) {
        const hiddenCards = getHiddenCards()
        loadMoreButton.hidden = hiddenCards.length ? false : true
      }
    }
  })
  } catch(e) { console.error(e); }
})();

})();
